<script>
import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'

import OrderAPI from './../../api/order.js';

export default {
  name: 'Order Tracking',
  components: {
    Footer,
    HeaderFive
  },
  watch: {
    show_error (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value == true) {
        setTimeout(() => {
            this.show_error = false;
          this.error_message = '';
        }, 5000)
      }
    }
  },
  data () {
    return {
        submit: false,
        error_message: '',
        show_error: false,
        email_address: '',
        order_id: '',
        order_result: null,
        show_result: false
    }
  },
  methods: {
    resetTracking()
    {
        this.show_result = false;
        this.order_result = null;
        this.email_address = '';
        this.order_id = '';
    },
    trackOrder()
    {
        this.submit = true;
        if(this.email_address == '')
        {
            this.error_message = 'Please enter email address';
            this.submit = false;
            this.show_error = true;
            this.$refs['anchor'].scrollIntoView({ behavior: 'smooth' })
        }
        else if(this.order_id == '')
        {
            this.error_message = 'Please enter order id';
            this.submit = false;
                this.show_error = true;
            this.$refs['anchor'].scrollIntoView({ behavior: 'smooth' })
        }
        else
        {
            try {
                var order_data_request = OrderAPI.trackOrder(this.email_address, this.order_id);
                order_data_request.then((order_data)=>{
                    if(order_data.code == 200 || order_data.code == "200")
                    {
                        this.order_result = order_data.description;

                         // Transform Free Items Data
                        var free_items = [];
                        this.order_result.free_items.forEach((free, free_index)=>{
                          var item_index = null;
                          var added_quantity = 0;

                          free_items.forEach((fi, fi_index)=>{
                            if(free.product_name == fi.product_name)
                            {
                              item_index = fi_index;
                              added_quantity = parseInt(fi.quantity);
                            }
                          });

                          if(item_index == null)
                          {
                            free_items.push(free);
                          }
                          else
                          {
                            free_items[item_index].quantity = parseInt(free_items[item_index].quantity) + parseInt(added_quantity);
                          }
                        });

                        this.order_result.free_items = free_items;


                        this.show_result = true;
                        this.submit = false;

                    }
                    else
                    {
                        if(typeof order_data.errors == 'string')
                        {
                            this.error_message = order_data.message;
                        }
                        else
                        {
                            for (const field in order_data.errors) {
                                  order_data.errors[field].forEach((error, error_index) =>{
                                      this.error_message = error;
                                  });
                              };
                        }
                    

                        
                         this.show_result = false;
                        this.submit = false;
                            this.show_error = true;
                    }
                    
                });
            } catch (error) {
                this.error_message = error;
                this.submit = false;
                    this.show_error = true;
            }
        }
    }
  },
  created()
  {
    var email_address = (this.$route.query.email ? this.$route.query.email : (this.$route.query.mobile ? this.$route.query.mobile : ''));
    var order_id = (this.$route.query.order ? this.$route.query.order : (this.$route.query.refno ? this.$route.query.refno : ''));
 
    if(email_address != '' || order_id != '')
    {
        this.email_address = email_address;
        this.order_id = order_id;
        this.trackOrder();
    }
  }
}
</script>

<template>
  <div class="page about-page">
      <HeaderFive />

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                            <h6 class="section-subtitle ltn__secondary-color">//  Welcome to our company</h6>
                            <h1 class="section-title white-color">Order Tracking</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Order Tracking</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- LOGIN AREA START -->
    <div class="ltn__login-area mb-120" ref="anchor">
        <div class="container">
            <div class="row" v-if="!show_result">
                <div class="col-lg-8 offset-lg-2">
                    <div class="account-login-inner section-bg-1">
                        <div class="ltn__form-box contact-form-box">
                            <p class="text-center"> To track your order please enter your Order ID in the box below and press the "Track Order" button. This was given to you on your receipt and in the confirmation email you should have received. </p>
                            <p v-if="error_message" class="error-message">{{ error_message }}</p>
                            <label>Order ID</label>
                            <input type="text" name="order_id" v-model="order_id" placeholder="Found in your order confirmation email.">
                            <label>Email Address</label>
                            <input type="text" name="email" v-model="email_address" placeholder="Email you used during checkout.">
                            <div class="btn-wrapper mt-0 text-center">
                                <button class="btn theme-btn-1 btn-effect-1 text-uppercase" :disable="submit" type="button" @click="trackOrder">{{ submit ? 'Loading...' : 'Track Order'}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="show_result">
                <div class="col-lg-8 offset-lg-2">
                    <div class="account-login-inner section-bg-1">
                        <div class="ltn__form-box contact-form-box  justify-content-center">
                            <h1 class="text-center">Tracking Result</h1>
                            <p class="text-center">Our staff and driver will keep in touch with you through every update</p>
                           <div class=" order-details-body mb-5 ">
                                 <div class="row justify-content-center">
                                    <div class="col-4">
                                        Status
                                    </div>
                                    <div class="col-4">
                                        {{ (order_result.status) }}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        Order ID
                                    </div>
                                    <div class="col-4">
                                        {{ (order_result.order_id) }}
                                    </div>
                                </div>
                                 <div class="row justify-content-center">
                                    <div class="col-4">
                                        Order Placed
                                    </div>
                                    <div class="col-4">
                                        {{ (order_result.date) }}
                                    </div>
                                </div>
                                 <div class="row justify-content-center">
                                    <div class="col-4">
                                       Actual Delivery Date
                                    </div>
                                    <div class="col-4">
                                        {{  order_result.shipping_method == 'Scheduled Delivery' ? (((order_result.status).toLowerCase() == "completed" || 
                                            (order_result.status).toLowerCase() == "cancelled" || 
                                            (order_result.status).toLowerCase() == "ready for delivery") ? (order_result.apickup_date)  : '') : order_result.apickup_date }}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        Subtotal
                                    </div>
                                    <div class="col-4">
                                        {{ (order_result.subtotal) | currencyFormat }}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        Shipping Fee
                                    </div>
                                    <div class="col-4">
                                        {{ (order_result.shipping_fee) | currencyFormat }}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-4">
                                        Total
                                    </div>
                                    <div class="col-4">
                                        {{ (order_result.total) | currencyFormat }}
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-8">
                                     <h4 class="mt-4">Orders</h4>
                                  </div> 
                                </div>
                                <div class="row justify-content-center" v-for="product in order_result.products">
                                    <div class="col-4">
                                        {{ product.name }} x {{ product.quantity }}
                                    </div>
                                     <div class="col-4">
                                       {{ product.total | currencyFormat }}
                                            
                                    </div>
                                </div>

                                 <div class="row justify-content-center" v-for="free in order_result.free_items">
                                    <div class="col-4">
                                        {{ free.product_name }} x {{ free.quantity }}
                                    </div>
                                     <div class="col-4">
                                       FREE
                                            
                                    </div>
                                </div>
                            </div>
                            <div class="btn-wrapper mt-0 text-center">
                                <button class="btn theme-btn-1 btn-effect-1 text-uppercase" :disable="submit" type="button" @click="resetTracking">Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- LOGIN AREA END -->

    <Footer />
  </div>
</template>
<style scoped>
    p.error-message {
        color: red;
        background: #ff000012;
        padding: 1rem;
        border-radius: 5px;
    }

    .contact-form-box{
        background-color: var(--section-bg-1);
    }
</style>


// WEBPACK FOOTER //
// src/components/page/OrderTracking.vue